
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { GetWorkorderDetails, DownloadAttachment, DeleteComments, GetStandardFields } from "action/workorderAction";
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import WorkSummaryMobileTabSystem from 'components/FacilityRequestComponents/Maintenance/WorkSummaryMobileTabSystem';
import AddCommentModal from 'components/FacilityRequestComponents/Maintenance/AddCommentModal';

import { Table, Modal } from "reactstrap";
import styles from './maintenance.module.css';
import tableStyles from './ImagesTable.module.css';
import PencilIcon from 'Assets/icons/pen.svg';
import { FaTrash } from 'react-icons/fa';


class ViewMaintenance extends Component {

    componentWillMount() {
        this.props.GetStandardFields();
        let maintenanceID = this.props.location.pathname.split('=')[1];
        (maintenanceID !== undefined) ?
            this.props.GetWorkorderDetails(maintenanceID) :
            console.log("redirect back");
    }

    constructor(props) {
        super(props);
        this.state = {
            redirect_to_editMaintenance: false,
            editMaintenanceID: null,
            maintenanceData: null,
            modal: false,
            editcommentDataState: null,
            editcommentIDState: null,

        }

        this.AttachmentDownload = this.AttachmentDownload.bind(this);
        this.toggle = this.toggle.bind(this);
        this.editComment = this.editComment.bind(this);
        this.deleteComment = this.deleteComment.bind(this);
        this.mobileActions = this.mobileActions.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.MaintenanceDetailInStore !== nextProps.MaintenanceDetailInStore) {
            this.setState({ maintenanceData: nextProps.MaintenanceDetailInStore });
        }
    }

    EditWorkOrderDetails(WorkOrderID) {
        this.setState({ editMaintenanceID: WorkOrderID, redirect_to_editMaintenance: true });
    }

    AttachmentDownload(fileName) {
        this.props.DownloadAttachment(fileName);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal, editcommentDataState: null, editcommentIDState: null
        });
    }

    editComment(el) {
        this.setState({ editcommentIDState: el.commentId, editcommentDataState: el.comments, modal: !this.state.modal });
    }

    render() {
        const { redirect_to_editMaintenance, editMaintenanceID, maintenanceData, editcommentIDState, editcommentDataState } = this.state;
        let { getLabels } = this.props;
        let serialNumber, statusText, description, createdByUser, createdByDate, image_records, comments_records, parts_records, labor_records, statusLabel, descriptionLabel, createdbyLabel  = null;
        let preferredfields = this.props.getWorkorderPreferences;

        if(preferredfields !== undefined && !preferredfields.hasOwnProperty('statusText')){
            preferredfields.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel !== "") ? fields.fieldLabel : getLabels['WorkOrderSetup.Options.' + fields.fieldId + '.Text'];
                if (fields.value.length > 0 && fields.fieldId === 1) {
                    fields.value.forEach(el => {
                        if (fields.fieldId === 1 && el.isCustom === false && el.value === "") {
                            el.value = getLabels['WorkOrders.Status.' + el.key + '.Text'];
                        }
                    });
                }
            });
            statusLabel = preferredfields.filter(x => x.field === "Status" && x.display === true);
            descriptionLabel = preferredfields.filter(x => x.field === "Description" && x.display === true);
            createdbyLabel =  preferredfields.filter(x => x.field === "Created" && x.display === true);
          }
          else{
             statusLabel =  "";
             descriptionLabel =  "";
             createdbyLabel = "";
          }  // To be removed conditions has to be validated using null not string.
      

        //Redirect to view maintenance page
        if (redirect_to_editMaintenance) {
            return <Redirect to={{ pathname: '/FacilityManagement/EditMaintenance/MR=' + editMaintenanceID }} />
        }


        if (maintenanceData !== null && maintenanceData !== undefined && !maintenanceData.hasOwnProperty('statusText')) {

            serialNumber = maintenanceData.serialNumber;
            if (statusLabel.length > 0 && statusLabel[0].value.length > 0) {
                var SelectedStatus = statusLabel[0].value.filter(el => el.key === maintenanceData.status);
                statusText = SelectedStatus[0] !== undefined ? SelectedStatus[0].value : "Not Assigned";
            }
            else{
                statusText = (maintenanceData.status > 0) ? this.props.getLabels['WorkOrders.Status.' + maintenanceData.status + '.Text'] : "Not Assigned";
            }
            description = maintenanceData.description;
            createdByUser = maintenanceData.createdByUserName;
            createdByDate = new Date(maintenanceData.createdByDate).toDateString();

            image_records = (maintenanceData.workOrderAttachment.length !== 0) ?
                maintenanceData.workOrderAttachment.map((el, index) => {
                    return <tr key={index}><td className={styles.textDecoration}><p onClick={() => { this.AttachmentDownload(el.fileName) }}>{el.attachmentName}</p></td></tr>
                })
                : <tr><td className={styles.norecords_text}>{"No entry"}</td></tr>;

            comments_records = (maintenanceData.workOrderComment.length !== 0) ?
                maintenanceData.workOrderComment.map((el, index) => {
                    return <tr key={index}>
                        <td>{el.comments}</td>
                        <td>{el.createdByUserName}</td>
                        <td> {new Date(el.createdOn).toDateString()}</td>
                        <td>{(maintenanceData.createdByUserID === el.createdByUserID) ?
                            <span>
                                <img src={PencilIcon} alt="Trane Logo" className={styles.comments_edit_icon} onClick={() => { this.editComment(el) }} />
                                <FaTrash className="Ensemble_Icon link_cursor" style={{ valign: 'bottom' }} onClick={() => { this.deleteComment(el.commentId) }} /></span> : null}
                        </td>
                    </tr>
                })
                : <tr><td className={styles.norecords_text}>{"No entry"}</td><td></td><td></td><td></td></tr>;

            parts_records = (maintenanceData.workOrderPart.length !== 0) ?
                maintenanceData.workOrderPart.map((el, index) => {
                    return <tr key={index}>
                        <td>{el.partName}</td>
                        <td>{el.partNumber}</td>
                        <td>{el.quantity}</td>
                    </tr>
                })
                : <tr><td className={styles.norecords_text}>{"No entry"}</td><td></td><td></td></tr>;


            labor_records = (maintenanceData.workOrderLabor.length !== 0) ?
                maintenanceData.workOrderLabor.map((el, index) => {
                    return <tr key={index}>
                        <td>{el.userName}</td>
                        <td>{new Date(el.dateOfService).toDateString()}</td>
                        <td>{el.regularHour}</td>
                        <td>{el.timeDuration}</td>
                    </tr>
                })
                : <tr><td className={styles.norecords_text}>{"No entry"}</td><td></td><td></td><td></td></tr>;

        }



        return (
            <div>

                <SubTitle text={serialNumber} />
                <img src={PencilIcon} alt="Trane Logo" className={styles.edit_icon} onClick={() => { this.EditWorkOrderDetails(maintenanceData.workOrderID) }} />

                <div className={styles.whiteContainer}>
                    {/* Status Container */}
                    <div className={styles.statusContainer}>
                        <p className={styles.statuslabel}>{(statusLabel.length > 0) ? statusLabel[0].fieldLabel : "Status"}</p>
                        <p className={styles.statusTextStyle}> {statusText}</p>
                    </div>

                    {/* Documents Section */}
                    <div className={styles.documentsSections} >
                        {/* Status Container */}
                        <div className={styles.viewForm}>
                            <p className={styles.viewFormlabel}>{(descriptionLabel.length > 0) ? descriptionLabel[0].fieldLabel: "Description"}</p>
                            <p className={styles.viewFormText}>{description}</p>
                            <p className={styles.viewFormlabel}>{(createdbyLabel.length > 0) ? createdbyLabel[0].fieldLabel : "Created by"}</p>
                            <p className={styles.viewFormText}>{createdByUser + " | " + createdByDate}</p>
                        </div>

                        <p className={styles.documentsformLabel}>Attached Documents or Photos </p>
                        <div className={styles.tableContainer}>

                            <Table responsive className={tableStyles.greenTable}>
                                <tbody>
                                    <tr><th>FILE NAME</th></tr>
                                    {image_records}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>




                <div className={styles.greyContainer}>
                    <p className={styles.documentsformLabel} style={{ marginLeft: '20px', marginBottom: '10px' }}>Work Summary </p>


                    {/* //Desktop View  */}
                    <div className={styles.maintenanceDesktopViewTabs}>
                        <div className={styles.whiteContainer}>
                            <div className={styles.documentsSections} style={{ marginTop: '0px' }}>
                                <p className={styles.documentsformLabel}>Comments </p>
                                <div className={styles.addButtonContainer}>
                                    <button className="workorderedit-choosebtn" style={{ float: 'right', width: '125px', marginBottom: '4px' }} onClick={this.toggle}>{"ADD COMMENT"}</button>
                                </div>

                                <div className={styles.tableContainer}>
                                    <Table  className={tableStyles.greenTable}>
                                        <tbody>
                                            <tr><th  width="40%">COMMENTS</th><th  width="25%">CREATED BY</th><th  width="25%">CREATED DATE</th><th  width="10%"></th></tr>
                                            {comments_records}
                                        </tbody>
                                    </Table>

                                    <p className={styles.documentsformLabel} style={{marginTop:'20px'}}>Parts </p>
                                    <Table  className={tableStyles.greenTable}>
                                        <tbody>
                                            <tr><th  width="40%">NAME</th><th  width="30%">PART #</th><th  width="30%">QUANTITY</th></tr>
                                            {parts_records}
                                        </tbody>
                                    </Table>

                                    <p className={styles.documentsformLabel}  style={{marginTop:'20px'}}>Labor </p>
                                    <Table  className={tableStyles.greenTable}>
                                        <tbody>
                                            <tr><th  width="40%">NAME</th><th  width="20%">DATE OF SERVICE</th><th  width="20%">REGULAR HOURS</th><th  width="20%">OVERTIME</th></tr>
                                            {labor_records}
                                        </tbody>
                                    </Table>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* //Mobile View */}
                    <div className={styles.maintenanceMobileViewTabs}> 
                    <WorkSummaryMobileTabSystem className={styles.maintenanceMobileViewTabs} workOrderSummaryData={maintenanceData} onAction={this.mobileActions} onDelete={this.deleteComment}/> 
                    </div>

                    <Modal isOpen={this.state.modal} className={styles.commentModal} contentClassName={styles.CommentModalContent}  >
                        <AddCommentModal
                            onCloseModal={this.toggle}
                            createdUserID={(maintenanceData !== null) ? maintenanceData.createdByUserID : 0}
                            workOrderID={(maintenanceData !== null) ? maintenanceData.workOrderID : 0}
                            editcommentID={(editcommentIDState !== null) ? editcommentIDState : 0}
                            editcommentData={(editcommentDataState !== null) ? editcommentDataState : ""}
                        />
                    </Modal>

                </div>
            </div>
        );
    }

    deleteComment(ID) {
        var data = {
            WorkOrderID: this.state.maintenanceData.workOrderID,
            commentId: ID
        }
        this.props.DeleteComments(data);
    }

    mobileActions(data){
        if(data==="add"){
            this.toggle();
        }
        else 
            this.editComment(data);
    }
}


const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer.user_info,
        MaintenanceDetailInStore: state.WorkorderRootReducer.WorkOrderDetails,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetStandardFields : () => dispatch(GetStandardFields()),
        GetWorkorderDetails: (WorkOrderID) => dispatch(GetWorkorderDetails(WorkOrderID)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        DeleteComments: (data) => dispatch(DeleteComments(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewMaintenance);